<!-- <div class="modal-content"> -->
<div class="sim-modal-header">
  <div class="d-flex justify-content-between align-items-start w-100">
    <!-- content header -->
    <div>
      <p class="mb-1">
        Based on
        <span class="font-weight-600" *ngIf="tabname == 'job_description'">Job Description</span>
        <span class="font-weight-600" *ngIf="tabname == 'quick_search'">Quick Search</span>

      </p>
      <!-- <p class="f-12">You can modify your search based on filters below</p> -->
      <p class="mb-3" *ngIf="tabname == 'job_description'"><span class="font-weight-600 mr-3">Note:</span>Fields marked with "<i
          class="fa-thumbtack fas text-webbtree-green pointer"></i>" indicate mandatory inputs</p>
          <div>
            <p class="text-left mr-2 mb-0" *ngIf="!recCandLoader">
              <span class="font-weight-500 f-18">{{formatNumberToIndianFormat(recCandCount)}}</span> Candidates found
            </p>
            <div *ngIf="recCandLoader" class="spinner-border text-webbtree-green mb-3 mr-2">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

    </div>
    <!-- modal cta's -->
    <!-- <div class="d-flex ml-auto flex-column justify-content-between align-items-center"> -->
    <div class="d-flex align-items-center">

      <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-1" class="btn-trms-small"
        (click)="redirectToListing()"
        >Submit</button>
    </div>

    <!-- </div> -->
  </div>
  <div class="closemodal">
    <span class="pointer ml-2" (click)="redirectToListing('close')"><i class="fa-regular fa-xmark"></i></span>
  </div>
</div>
<!-- left col -->
<div class="p-2">
  <div class="row">
    <div class="col-md-6 mb-2">
      <!-- jobtitle -->
      <div class="d-flex flex-column fields-box h-100">
        <div class="d-flex flex-column fields-header">
          <span class="font-weight-600">Job Title</span>

        </div>

        <div class="mx-3 my-2">
          <!-- input box -->
          <div class="d-flex align-items-center mb-2">
            <div class="position-relative w-100">
              <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-1" class="sim-form-control no-shadow inputheight ml-0 w-100" #trigger="matAutocompleteTrigger"
                (click)="typeAheadSearch($event, 'jobTitle')"
                (keyup.enter)="addToSelectedList($event,'jobTitle', 'enter');$event.target.blur();trigger.closePanel()"
                (keyup)="onTypeAheadSearch($event, 'jobTitle')" placeholder="Add a new Job Title"
                [matAutocomplete]="jobtitle_auto" [formControl]="jobTitleInput" (blur)="removeTypeahead('jobtitle')" />
              <div *ngIf="showJobtitleInputLoader" class="spinner-border position-absolute text-black"
                style="top: 10px; right: 7px; z-index: 2;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <mat-autocomplete #jobtitle_auto="matAutocomplete"
                (optionSelected)="addToSelectedList($event, 'jobTitle')">
                <mat-option *ngFor="let jt of jobTitleTypeAheads" [value]="{ key: jt.value, doc_count: jt.doc_count }"
                  [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                  matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value | titlecase}} </span>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- chiplist -->
          <div [ngClass]="{'px-1 mb-2 mt-4': jobTitleExtendedChipList.length}">
            <mat-chip-grid>
              <mat-chip-row class="chip"
                [ngStyle]="{ 'background-color': c.isSuggested ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }"
                *ngFor="let c of jobTitleExtendedChipList" (removed)="removeChip(c, 'jobtitle')" [value]="c">
                <span class="text-truncate mr-1" [matTooltip]="c.name | titlecase" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" style="font-weight: 400;">{{c.name | titlecase}}</span>
                <i class="fa-thumbtack pointer" *ngIf="c.canStar"
                  [matTooltip]="!c.starred ? 'Mark this as High Priority' : ''" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" [ngClass]="{ 'fas text-webbtree-green': c.starred, fal: !c.starred }"
                  (click)="toggleStar(c, 'jobtitle')"></i>
                <span matChipRemove  class="mr-1">
                  <i class="fas fa-times"></i>
                </span>
              </mat-chip-row>
            </mat-chip-grid>
            <!-- <app-extended-chiplist [chips]="jobTitleExtendedChipList" (change)="setUpdatedChips($event, 'jobTitle')"></app-extended-chiplist> -->
          </div>
          <!-- error message -->
          <p class="f-12 text-danger" *ngIf="showJobMantoryChip">Maximum one Job Title can be marked as
            mandatory</p>
          <p class="f-12 text-danger font-weight-500 mb-0 mt-2" *ngIf="showJobTitleError">Job title selection is
            mandatory</p>
          <!-- ai suggestion -->

        </div>
      </div>
    </div>

    <!-- Location -->
    <div class="col-md-6 mb-2">
      <div class="d-flex flex-column fields-box  h-100">
        <div class="d-flex flex-column fields-header">
          <span class="font-weight-600">Location</span>

        </div>
        <div class="mx-3 my-2">
          <div class="d-flex position-relative">
            <span class="dropdown ats-dropBtn">
              <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-2" class="dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton"
                appDropdownToggle aria-haspopup="true" aria-expanded="false">
                <div class="d-flex align-items-center text-truncate" [ngStyle]=" { 'width': '80px'}">
                  <i class="fas fa-earth mr-1"></i>
                  <span class="text-capitalize mr-1 text-truncate">{{showregion == 'asia' ? 'Asia': showregion ==
                    'africa'? 'Africa': showregion == 'north america' ? 'North America': showregion == 'oceania' ?
                    'Oceania': 'South America'}}</span>
                  <i class="fas fa-chevron-down f-14"></i>
                </div>
              </button>
              <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                <div class="d-flex justify-content-between mb-3">
                  <p class="f-16 font-weight-500 text-black mb-0">Select Continent</p>
                  <div>
                    <span><i class="fas fa-times pointer"></i></span>
                  </div>

                </div>
                <div class="d-flex mb-4">
                  <div>
                    <div class="region-box mb-1  pointer"
                      [ngClass]="{'border-blue': showregion === 'north america',  'border-gray': showregion !== 'north america'}"
                      style="margin-right: 18px;" (click)="selectRegion('north america')">
                      <img src="../../assets/images/north-america.png" class="img-fluid w-100" alt="">
                    </div>
                    <p class="text-black f-14 mb-0">North America</p>
                  </div>
                  <div>
                    <div class="region-box  mb-1 pointer"
                      [ngClass]="{'border-blue': showregion === 'asia',  'border-gray': showregion !== 'asia'}"
                      (click)="selectRegion('asia')">
                      <img src="../../assets/images/asia.png" class="img-fluid w-100" alt="">
                    </div>
                    <p class="text-black f-14 mb-0">Asia</p>
                  </div>
                </div>
                <div class="d-flex mb-4">
                  <div>
                    <div class="region-box mb-1 pointer"
                      [ngClass]="{'border-blue': showregion === 'south america', 'border-gray': showregion !== 'south america'}"
                      style="margin-right: 18px;" (click)="selectRegion('south america')">
                      <img src="../../assets/images/south-america.png" class="img-fluid w-100" alt="">
                    </div>
                    <p class="text-black f-14 mb-0">South America</p>
                  </div>
                  <div>
                    <div class="region-box border-gray mb-1"
                      [ngClass]="{'border-blue': showregion === 'africa', 'border-gray': showregion !== 'africa'}"
                      style="margin-right: 18px;" (click)="selectRegion('africa')">
                      <img src="../../assets/images/africa.png" class="img-fluid w-100" alt="">
                    </div>
                    <p class="text-black f-14 mb-0">Africa</p>
                  </div>
                </div>
                <div class="d-flex">
                  <div>
                    <div class="region-box mb-1 pointer"
                      [ngClass]="{'border-blue': showregion === 'oceania', 'border-gray': showregion !== 'oceania'}"
                      style="margin-right: 18px;" (click)="selectRegion('oceania')">
                      <img src="../../assets/images/oceania.png" class="img-fluid w-100" alt="">
                    </div>
                    <p class="text-black f-14 mb-0">Oceania</p>
                  </div>
                </div>
              </div>
            </span>
            <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-2" type="text" class="wc-form-control webbtree-location-chip" placeholder="Enter a Location(s)" [formControl]="locationInput"
              (keyup.enter)="addToSelectedList($event,'location', 'enter');$event.target.blur();trigger.closePanel()"
              (keyup)="onTypeAheadSearch($event, 'location')" [matAutocomplete]="location_auto"

              (blur)="removeTypeahead('location')">
              <div *ngIf="showLocationInputLoader" class="spinner-border position-absolute text-black"
                style="top: 10px; right: 7px; z-index: 2;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="addToSelectedList($event, 'location')">
              <mat-option *ngFor="let lt of locationTypeAheads" [value]="{key: lt.value, doc_count: lt.doc_count}"
                [matTooltip]="lt.value | titlecase">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{lt.value | titlecase}} </span>
                  <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
          </div>

          <!-- chiplist -->
          <div [ngClass]="{'px-1 mb-2 mt-4': locationExtendedChipList.length}">
            <mat-chip-grid>
              <mat-chip-row class="chip"
                [ngStyle]="{ 'background-color': c.isSuggested ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }"
                *ngFor="let c of locationExtendedChipList" (removed)="removeChip(c, 'location')" [value]="c">
                <span class="text-truncate mr-1" [matTooltip]="c.name | titlecase" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" style="font-weight: 400;">{{c.name | titlecase}}</span>
                <i class="fa-thumbtack pointer" *ngIf="c.canStar"
                  [matTooltip]="!c.starred ? 'Mark this as High Priority' : ''" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" [ngClass]="{ 'fas text-webbtree-green': c.starred, fal: !c.starred }"
                  (click)="toggleStar(c, 'location')"></i>
                <span matChipRemove  class="mr-1">
                  <i class="fas fa-times"></i>
                </span>
              </mat-chip-row>
            </mat-chip-grid>
            <!-- <app-extended-chiplist [chips]="jobTitleExtendedChipList" (change)="setUpdatedChips($event, 'jobTitle')"></app-extended-chiplist> -->
          </div>
          <!-- error message -->
          <p class="f-12 text-danger" *ngIf="showLocationMandatoryChip">Maximum one Location can be marked as
            mandatory</p>
          <p class="f-12 text-danger font-weight-500 mb-0 mt-2" *ngIf="showLocationError">Location selection is mandatory
          </p>
          <!-- ai suggestion -->
      </div>
      </div>
    </div>

  </div>
  <div class="row mb-2">
    <div class="col">
      <!-- jobtitle -->
      <div class="d-flex flex-column fields-box">
        <div class="d-flex flex-column fields-header">
          <span class="font-weight-600">Skills</span>

        </div>

        <div class="mx-3 my-2">
          <!-- input box -->
          <div class="d-flex align-items-center mb-2">
            <div class="position-relative w-100">
              <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-3" class="sim-form-control no-shadow inputheight ml-0 w-100" #trigger="matAutocompleteTrigger"
                (click)="typeAheadSearch($event, 'skills')"
                (keyup.enter)="addToSelectedList($event,'skills', 'enter');$event.target.blur();trigger.closePanel()"
                (keyup)="onTypeAheadSearch($event, 'skills')" placeholder="Skills" [matAutocomplete]="skills_auto"
                [formControl]="skillsInput" (blur)="removeTypeahead('skills')" />
              <div *ngIf="showSkillsInputLoader" class="spinner-border position-absolute text-black"
                style="top: 10px; right: 7px; z-index: 2;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="addToSelectedList($event, 'skills')">
                <mat-option *ngFor="let st of skillsTypeahead" [value]="{ key: st.value, doc_count: st.doc_count }"
                  [matTooltip]="st.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                  matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{st.value | titlecase}} </span>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- chiplist -->
          <div [ngClass]="{'px-1 mb-2 mt-4': skillsExtendedChipList.length}">
            <mat-chip-grid>
              <mat-chip-row class="chip"
                [ngStyle]="{ 'background-color': c.isSuggested ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }"
                *ngFor="let c of skillsExtendedChipList" (removed)="removeChip(c, 'skills')" [value]="c">
                <span class="text-truncate mr-1" [matTooltip]="c.name | titlecase" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" style="font-weight: 400;">{{c.name | titlecase}}</span>
                <i class="fa-thumbtack pointer" *ngIf="c.canStar"
                  [matTooltip]="!c.starred ? 'Mark this as High Priority' : ''" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" [ngClass]="{ 'fas text-webbtree-green': c.starred, fal: !c.starred }"
                  (click)="toggleStar(c, 'skills')"></i>
                <span matChipRemove  class="mr-1">
                  <i class="fas fa-times"></i>
                </span>
              </mat-chip-row>
            </mat-chip-grid>
            <!-- <app-extended-chiplist [chips]="jobTitleExtendedChipList" (change)="setUpdatedChips($event, 'jobTitle')"></app-extended-chiplist> -->
          </div>
          <!-- error message -->
          <p class="f-12 text-danger" *ngIf="showSkillsMandatoryChip">Maximum five Skills can be marked as
            mandatory</p>

          <!-- ai suggestion -->

        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-2">
      <!-- jobtitle -->
      <div class="d-flex flex-column fields-box  h-100">
        <div class="d-flex flex-column fields-header">
          <span class="font-weight-600">Company</span>

        </div>

        <div class="mx-3 my-2">
          <!-- input box -->
          <div class="d-flex align-items-center mb-2">
            <div class="position-relative w-100">
              <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-4" class="sim-form-control no-shadow inputheight ml-0 w-100" #trigger="matAutocompleteTrigger"
                (click)="typeAheadSearch($event, 'company')"
                (keyup.enter)="addToSelectedList($event,'company', 'enter');$event.target.blur();trigger.closePanel()"
                (keyup)="onTypeAheadSearch($event, 'company')" placeholder="Company" [matAutocomplete]="company_auto"
                [formControl]="companyInput" (blur)="removeTypeahead('company')" />
              <div *ngIf="showCompanyInputLoader" class="spinner-border position-absolute text-black"
                style="top: 10px; right: 7px; z-index: 2;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="addToSelectedList($event, 'company')">
                <mat-option *ngFor="let ct of companyTypeahead" [value]="{ key: ct.value, doc_count: ct.doc_count }"
                  [matTooltip]="ct.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                  matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{ct.value | titlecase}} </span>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- chiplist -->
          <div [ngClass]="{'px-1 mb-2 mt-4': companyExtendedChipList.length}">
            <mat-chip-grid>
              <mat-chip-row class="chip"
                [ngStyle]="{ 'background-color': c.isSuggested ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }"
                *ngFor="let c of companyExtendedChipList" (removed)="removeChip(c, 'company')" [value]="c">
                <span class="text-truncate mr-1" [matTooltip]="c.name | titlecase" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" style="font-weight: 400;">{{c.name | titlecase}}</span>
                <i class="fa-thumbtack pointer" *ngIf="c.canStar"
                  [matTooltip]="!c.starred ? 'Mark this as High Priority' : ''" matTooltipPosition="above"
                  matTooltipClass="ai-tooltip" [ngClass]="{ 'fas text-webbtree-green': c.starred, fal: !c.starred }"
                  (click)="toggleStar(c, 'company')"></i>
                <span matChipRemove  class="mr-1">
                  <i class="fas fa-times"></i>
                </span>
              </mat-chip-row>
            </mat-chip-grid>
            <!-- <app-extended-chiplist [chips]="jobTitleExtendedChipList" (change)="setUpdatedChips($event, 'jobTitle')"></app-extended-chiplist> -->
          </div>
          <!-- error message -->
          <p class="f-12 text-danger" *ngIf="showCompanyMandatoryChip">Maximum one Company can be marked as
            mandatory</p>

          <!-- ai suggestion -->

        </div>
      </div>
    </div>

    <!-- Location -->
    <div class="col-md-6 mb-2">
      <div class="upgrade-small flex-column fields-box  h-100">
        <div class="my-4 text-center">
          <span class="text-9696 f-16"> <i class="fa-solid fa-lock-keyhole"></i></span>
          <p class="f-14 font-weight-500 mb-2">Field Of Study</p>
          <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-3" class="btn-free-trial-primery" (click)="startFreeTrial('Filter_Modal_FieldOfStudy_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-md-6 mb-2">
      <div class="upgrade-small flex-column fields-box  h-100">
        <div class="my-4 text-center">
          <span class="text-9696 f-16"> <i class="fa-solid fa-lock-keyhole"></i></span>
          <p class="f-14 font-weight-500 mb-2">Degree</p>
          <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-4" class="btn-free-trial-primery" (click)="startFreeTrial('Filter_Modal_Degree_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

        </div>
      </div>
    </div>

    <div class="col-md-6 mb-2">
      <div class="upgrade-small flex-column fields-box  h-100">
        <div class="my-4 text-center">
          <span class="text-9696 f-16"> <i class="fa-solid fa-lock-keyhole"></i></span>
          <p class="f-14 font-weight-500 mb-2">Schools</p>
          <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-5" class="btn-free-trial-primery" (click)="startFreeTrial('Filter_Modal_Schools_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

        </div>
      </div>
    </div>

  </div>
  <div class="row mb-2">
    <div class="col card-blur-relative">
      <!-- jobtitle -->
      <div class="">
        <div class="d-flex flex-column fields-box ">
          <div class="d-flex flex-column fields-header">
            <span class="font-weight-500">Additional Filters</span>

          </div>


          <div class="my-3 py-3 card-blur-relative">
            <div class="card-blur">
              <div class="row mb-2">
                <div class="col">
                  <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-5" class="sim-form-control no-shadow inputheight ml-0 w-100" placeholder="Past Job Title">
                </div>

                <div class="col">
                  <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-6" class="sim-form-control no-shadow inputheight ml-0 w-100" placeholder="Functions">
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-7" class="sim-form-control no-shadow inputheight ml-0 w-100" placeholder="Distance">
                </div>

                <div class="col">
                  <input data-testid="auto-app-webbtree-jd-search-filter-modal-input-8" class="sim-form-control no-shadow inputheight ml-0 w-100" placeholder="Years of Experience">
                </div>
              </div>
            </div>
            <div class="on-blur-free-trial">
              <div class="my-4 text-center">
                <span class="text-9696 f-16"> <i class="fa-solid fa-lock-keyhole"></i></span>
                <p class="f-14 mb-4 font-weight-500">Upgrade To access 15+ Filters</p>
                <button data-testid="auto-app-webbtree-jd-search-filter-modal-button-6" class="btn-free-trial-primery" (click)="startFreeTrial('Filter_Modal_AdditionalFilter_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>
              </div>
            </div>


      </div>
        </div>
      </div>

    </div>
  </div>
</div>
